import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from '@deckspace/client';
import { SignIn } from './pages/SignIn';
import { Home } from './pages/Home';
import { Workspace } from './pages/Workspace';
import { WorkspaceRedirect } from './pages/WorkspaceRedirect';
import { Settings } from './pages/Settings';
import { AppLayout } from './layouts/AppLayout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/w/:id" element={<WorkspaceRedirect />} />
        <Route path="/w/:id/:pageId" element={<Workspace />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default App;
